var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00008b",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.5 0 10.1 7.5L23.8 0H27v2.6L17 10l10 7.5V20h-3.3l-10-7.5-10 7.5H.3v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m18 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H.3zM27 0v.1L16.6 8l.1-1.9L25 0zM.3 0l10 7.3H7.8L.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4 0v20H17V0zM.4 6.7v6.6H27V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.3 8v4H27V8zm11.4-8v20h4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m44.3 33-1.8.3.2 1.7-1.2-1.2-1.2 1.2.1-1.7-1.7-.2 1.5-1-1-1.4 1.7.5.6-1.6.6 1.6 1.6-.5-1 1.4zm-.4-9.7.3-1-.9-.8 1.2-.2.4-1 .5 1 1 .2-.7.7.2 1-1-.5zm-8.6-5-1.7.2.1 1.7-1.2-1.2-1.2 1.1.2-1.7-1.7-.2 1.4-.9-.8-1.4 1.6.5.6-1.6.5 1.6 1.7-.5-1 1.5zm17-2.7-1.8.2.2 1.7-1.3-1.2-1.2 1.2.2-1.7-1.8-.2 1.5-1-1-1.5 1.7.6.6-1.7.6 1.7 1.7-.6-1 1.5zm-8-7-1.8.2.2 1.7-1.2-1.2-1.3 1.2.2-1.7-1.7-.3 1.4-.9-.9-1.5 1.7.6.6-1.6.6 1.6 1.6-.5-1 1.4zM19.7 32.1l-3.8.5.4 3.8-2.7-2.7-2.8 2.7.4-3.8-3.8-.5 3.3-2-2-3.4 3.6 1.3 1.3-3.6L15 28l3.6-1.2-2 3.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/au.1b501c4e76f4e42033085a266f99673f.svg";
export { ForwardRef as ReactComponent };